module.exports = now

function now() {
    return new Date().getTime()
}



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/console-browserify/~/date-now/index.js
 ** module id = 7
 ** module chunks = 1
 **/